var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _line, _line2, _line3, _line4, _line5, _line6, _rect11, _rect12, _rect13, _line7, _line8, _line9, _line10, _line11, _line12, _rect14, _rect15, _rect16, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _circle, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCalendarQuarter3SpringIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.c,.d{fill:#89d9fb;}.c,.g,.h{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;}.c{stroke-width:2px;}.e{fill:#fff;}.f{fill:#ffefe0;}.g,.h{stroke-width:2px;}.h{fill:#e5e5e5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-calendar-quarter-3-spring-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 45.93,
    y: 11.4,
    width: 54.13,
    height: 31.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 45.93,
    y: 46.5,
    width: 54.13,
    height: 24.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 45.93,
    y: 75,
    width: 54.13,
    height: 24.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 45.93,
    y: 103.5,
    width: 54.13,
    height: 31.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 39.93,
    y: 5.4,
    width: 54.13,
    height: 31.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 39.93,
    y: 121.99,
    width: 54.13,
    height: 6.61
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 39.93,
    y: 40.5,
    width: 54.13,
    height: 24.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 67,
    y: 40.5,
    width: 27.07,
    height: 24.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 39.93,
    y: 40.5,
    width: 54.13,
    height: 24.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 34.5,
    x2: 45.93,
    y2: 42.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 54.36,
    y1: 34.5,
    x2: 54.36,
    y2: 42.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 34.5,
    x2: 62.79,
    y2: 42.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 71.21,
    y1: 34.5,
    x2: 71.21,
    y2: 42.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 34.5,
    x2: 79.64,
    y2: 42.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 88.07,
    y1: 34.5,
    x2: 88.07,
    y2: 42.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 39.93,
    y: 69,
    width: 54.13,
    height: 24.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 67,
    y: 69,
    width: 27.07,
    height: 24.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 39.93,
    y: 69,
    width: 54.13,
    height: 24.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 63,
    x2: 45.93,
    y2: 71
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 54.36,
    y1: 63,
    x2: 54.36,
    y2: 71
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 63,
    x2: 62.79,
    y2: 71
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 71.21,
    y1: 63,
    x2: 71.21,
    y2: 71
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 63,
    x2: 79.64,
    y2: 71
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 88.07,
    y1: 63,
    x2: 88.07,
    y2: 71
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 39.93,
    y: 97.5,
    width: 54.13,
    height: 24.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 67,
    y: 97.5,
    width: 27.07,
    height: 24.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 39.93,
    y: 97.5,
    width: 54.13,
    height: 31.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 91.5,
    x2: 45.93,
    y2: 99.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 54.36,
    y1: 91.5,
    x2: 54.36,
    y2: 99.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 91.5,
    x2: 62.79,
    y2: 99.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 71.21,
    y1: 91.5,
    x2: 71.21,
    y2: 99.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 91.5,
    x2: 79.64,
    y2: 99.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 88.07,
    y1: 91.5,
    x2: 88.07,
    y2: 99.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 50.33,
    x2: 54.36,
    y2: 50.33
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 55.17,
    x2: 54.36,
    y2: 55.17
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 50.33,
    x2: 71.21,
    y2: 50.33
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 55.17,
    x2: 71.21,
    y2: 55.17
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 50.33,
    x2: 88.07,
    y2: 50.33
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 55.17,
    x2: 88.07,
    y2: 55.17
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 67,
    cy: 11.75,
    r: 2.36
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 39.93,
    y1: 121.99,
    x2: 94.07,
    y2: 121.99
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 78.83,
    x2: 54.36,
    y2: 78.83
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 83.67,
    x2: 54.36,
    y2: 83.67
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 78.83,
    x2: 71.21,
    y2: 78.83
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 83.67,
    x2: 71.21,
    y2: 83.67
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 78.83,
    x2: 88.07,
    y2: 78.83
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 83.67,
    x2: 88.07,
    y2: 83.67
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 107.33,
    x2: 54.36,
    y2: 107.33
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 45.93,
    y1: 112.16,
    x2: 54.36,
    y2: 112.16
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 107.33,
    x2: 71.21,
    y2: 107.33
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 62.79,
    y1: 112.16,
    x2: 71.21,
    y2: 112.16
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 107.33,
    x2: 88.07,
    y2: 107.33
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 79.64,
    y1: 112.16,
    x2: 88.07,
    y2: 112.16
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCalendarQuarter3SpringIcon);
export default __webpack_public_path__ + "static/media/CP-calendar-quarter-3-spring-icon.b0869cfc291caaa11e223831a1389d78.svg";
export { ForwardRef as ReactComponent };